/* eslint-disable func-names, no-else-return, no-shadow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHighCharts from 'react-highcharts';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';
import { renderToString } from 'react-dom/server';
import Highcharts from 'highcharts';

import ProgressCircle from './ProgressCircle';
import { HighChartsFormatter, placeholderConfig } from './Highcharts';

const Plot = ReactHighCharts.withHighcharts(Highcharts);

@translate(['dashboard'], { wait: true })
class Scoring extends Component {
  shouldComponentUpdate(nextProps) {
    if (
      this.props.acceleratingReport.sum === nextProps.acceleratingReport.sum &&
      this.props.brakingReport.sum === nextProps.brakingReport.sum &&
      this.props.corneringReport.sum === nextProps.corneringReport.sum &&
      this.props.speedingReport.sum === nextProps.speedingReport.sum &&
      this.props.noRidesForMonth === nextProps.noRidesForMonth &&
      this.props.currentLanguage === nextProps.currentLanguage
    ) {
      return false;
    } else if (this.props.currentLanguage !== nextProps.currentLanguage) {
      this.forceUpdate();
    }

    return true;
  }

  render() {
    const { t, noRidesForMonth } = this.props;
    const totalAccelerations = this.props.acceleratingReport.sum || 0;
    const totalBrakings = this.props.brakingReport.sum || 0;
    const totalCornerings = this.props.corneringReport.sum || 0;
    const totalSpeedings = this.props.speedingReport.sum || 0;
    const date = moment()
      .utc()
      .subtract(29, 'days')
      .format('YYYY,M,D')
      .split(',');
    const start = Date.UTC(date[0], --date[1], date[2]);
    const pointInterval = 86400000;
    const accelerationsValues = this.props.acceleratingReport.values
      ? this.props.acceleratingReport.values
      : [];
    const corneringsValues = this.props.corneringReport.values
      ? this.props.corneringReport.values
      : [];
    const brakingsValues = this.props.brakingReport.values
      ? this.props.brakingReport.values
      : [];
    const speedingsValues = this.props.speedingReport.values
      ? this.props.speedingReport.values
      : [];
    const journeyScoreValues = this.props.journeyScoreReport.values
      ? this.props.journeyScoreReport.values
      : [];

    let config = {
      chart: { type: 'column' },
      tooltip: {
        formatter() {
          const index = (this.x - start) / pointInterval;
          return renderToString(
            <HighChartsFormatter
              score={parseInt(journeyScoreValues[index], 10) || 0}
              points={this.points || []}
              date={Highcharts.dateFormat('%e %b %Y', this.x)}
            />,
          );
        },
      },
      plotOptions: {
        series: {
          pointStart: start,
          pointInterval,
        },
      },
      series: [
        {
          name: t('dashboard:accelerations'),
          color: 'rgba(255,146,4,0.4)',
          states: { hover: { color: 'rgba(255,146,4,1)' } },
          data: accelerationsValues,
        },
        {
          name: t('dashboard:cornerings'),
          color: 'rgba(176,86,240,0.4)',
          states: { hover: { color: 'rgba(176,86,240,1)' } },
          data: corneringsValues,
        },
        {
          name: t('dashboard:brakings'),
          color: 'rgba(0,0,0,0.4)',
          states: { hover: { color: 'rgba(0,0,0,1)' } },
          data: brakingsValues,
        },
        {
          color: 'rgba(255,32,32,0.4)',
          states: { hover: { color: 'rgba(255,32,32,1)' } },
          name: t('dashboard:speedings'),
          data: speedingsValues,
        },
      ],
    };
    config = noRidesForMonth ? placeholderConfig(start) : config;
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <section className="container container-description">
          <h1>{t('dashboard:drive_points')}</h1>
          <p>{t('dashboard:drive_points_description')}</p>
        </section>
        <div className="basic-statistics">
          <div className="container">
            <div className="basic-statistics__info">
              <div className="basic-statistics__info__progress">
                <ProgressCircle />
              </div>
              <div className="basic-statistics__info__holder">
                <div className="basic-statistics__info__item">
                  <div className="result result-speed">{totalSpeedings}</div>
                  <div className="title">{t('dashboard:speedings')}</div>
                </div>
                <div className="basic-statistics__info__item">
                  <div className="result result-acceleration">
                    {totalAccelerations}
                  </div>
                  <div className="title">{t('dashboard:accelerations')}</div>
                </div>
                <div className="basic-statistics__info__item">
                  <div className="result result-maneuvers">
                    {totalCornerings}
                  </div>
                  <div className="title">{t('dashboard:cornerings')}</div>
                </div>
                <div className="basic-statistics__info__item">
                  <div className="result result-braking">{totalBrakings}</div>
                  <div className="title">{t('dashboard:brakings')}</div>
                </div>
              </div>
            </div>
            <Plot ref="chart" config={config} domProps={{ id: 'mainGraph' }} />
          </div>
        </div>
      </div>
    );
  }
}

Scoring.propTypes = {
  statistics: PropTypes.object,
  acceleratingReport: PropTypes.object,
  brakingReport: PropTypes.object,
  corneringReport: PropTypes.object,
  speedingReport: PropTypes.object,
  journeyScoreReport: PropTypes.object,
};

export default connect(
  state => ({
    noRidesForMonth: !(
      !state.rides.areJourneysForMonthLoaded ||
      state.rides.areJourneysForMonthExist
    ),
    statistics:
      state.statistics.statistics
        .filter(item => item.deviceId === state.devices.currentDevice.id)
        .pop() || {},
    acceleratingReport: state.dashboard.reports.acceleratingReport,
    brakingReport: state.dashboard.reports.brakingReport,
    corneringReport: state.dashboard.reports.corneringReport,
    speedingReport: state.dashboard.reports.speedingReport,
    journeyScoreReport: state.dashboard.reports.journeyScoreReport,
    currentLanguage: state.langs.currentLanguage,
  }),
  () => ({}),
)(Scoring);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Scoring.js